// jshint module: true

import Component from './../../assets/scripts/component/component';
import fireCustomEvent from './../../assets/scripts/modules/fire-custom-event';

const component = 'router';
const selector = `.${component}`;

class Router extends Component {

  constructor(name, element, options) {
    super(name, element, options);
  }

  init() {

    this.pages = [...document.querySelectorAll('.page')];
    this.currentPage = '';

    if (!this.pages) {
      return;
    }

    this.tryNavigateToPage(this.findCurrentPage());
    document.documentElement.addEventListener('click', event => this.onClickHandler(event), true);

    window.addEventListener('popstate', (event) => this.tryNavigateToPage(this.findCurrentPage()), false);

  }

  findCurrentPage() {
    let parts = [];

    // Get from url hash
    if (window.location.pathname.length > 1 && window.location.pathname[0] === '/') {
      parts = window.location.pathname.split('/').filter(part => part.length);
    }

    // Otherwise, pick the first page on the page
    if (!parts.length) {
      parts = [ this.pages[0].id ];
    }

    return parts[0];
  }

  tryNavigateToPage(name) {
    const page = document.getElementById(name);

    if (!page || !page.classList.contains('page')) {
      return false;
    }

    this.currentPage = page;
    window.history.pushState({ url: `/${name}/` }, '', `/${name}/`);
    page.classList.add('will-be-target');

    fireCustomEvent('page-change', this.currentPage);

    return true;
  }

  onClickHandler(event) {
    const element = event.target;
    const href = (element.href || '#').split('#');

    if (!href || !href[1]) {
      return;
    }

    const parts = href[1].split('/').filter(part => part.length);

    if (!parts) {
      return;
    }

    const page = this.pages.filter(page => page.id === parts[0]);

    if (!page) {
      return;
    }

    if (this.tryNavigateToPage(parts[0])) {
      event.preventDefault();
    }

  }

}

for (const element of document.querySelectorAll(selector)) {
  element.instance = new Router(component, element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/router/router.js